import { Link, useLocation } from 'react-router-dom'
import { 
  Video, 
  Flag, 
  LogOut,
  Shield,
  MessageSquare,
  UserCog,
  Mail
} from 'lucide-react'
import { useAuth } from '../hooks/useAuth'

interface LayoutProps {
  children: React.ReactNode
}

const navigation = [
  { name: 'Videos', href: '/videos', icon: Video },
  { name: 'Reports', href: '/reports', icon: Flag },
  { name: 'AI Reports', href: '/ai-reports', icon: MessageSquare },
  { name: 'Waitlist', href: '/waitlist', icon: Mail },
  { name: 'Admins', href: '/admins', icon: UserCog },
  /* { name: 'Audit Log', href: '/audit', icon: FileText }, */
]

export function Layout({ children }: LayoutProps) {
  const location = useLocation()
  const { admin, logout } = useAuth()

  const handleLogout = async () => {
    await logout()
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <div className="fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-lg">
        <div className="flex h-16 items-center px-6 border-b">
          <Shield className="h-8 w-8 text-red-600" />
          <h1 className="ml-2 text-xl font-bold text-gray-900">Valentine Admin</h1>
        </div>
        
        <nav className="mt-8 px-4">
          <ul className="space-y-2">
            {navigation.map((item) => {
              const isActive = location.pathname === item.href
              return (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className={`flex items-center px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                      isActive
                        ? 'bg-red-50 text-red-700 border-r-2 border-red-600'
                        : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                    }`}
                  >
                    <item.icon className="mr-3 h-5 w-5" />
                    {item.name}
                  </Link>
                </li>
              )
            })}
          </ul>
        </nav>

        {/* User info and logout */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t">
          <div className="flex items-center gap-2 min-w-0">
            <div className="h-8 w-8 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-sm font-medium text-red-600">
                {admin?.email?.charAt(0).toUpperCase()}
              </span>
            </div>
            <div className="ml-3 min-w-0 flex-1 overflow-x-auto scrollbar-hide">
              <p className="text-sm font-medium text-gray-900 whitespace-nowrap">{admin?.email}</p>
            </div>
            <button
              onClick={handleLogout}
              className="p-2 text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
              title="Logout"
            >
              <LogOut className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="pl-64">
        <main className="py-8">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}
